import axios from '../utils/axios';

export default function getSeekerProfile(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/profile-data`, { params })
        .then(response => {
            console.log(`getSeekerProfile: `,JSON.stringify(response));
            if (response.data && response.data.data) {
                const details = {
                    id: response.data.data.data.id,
                    name: response.data.data.data.name,
                    email: response.data.data.data.email,
                    ip_address: response.data.data.data.ipAddress,
                    prouser: response.data.data.data.isProUser ? 1 : 0
                };
                return details;
            }
            return null;
        })
        .catch(err => {
            console.log(err);
            return null;
        });
}